import "./partner.scss";
import { type FC } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import BoxForm from "../../Common/BoxForm/BoxForm";
import Button from "../../Common/Button";
import { type RootState } from "../../Reducers/DeveloperReducers";
import { useTitle } from "../../Utilities/TitleHook";
import { PartnerRegistrationBackground } from "./PartnerRegistrationBackground";

const PartnerProgram: FC = () => {
    const user = useSelector((state: RootState) => state.user.user);

    useTitle("Partner Program");

    return (
        <main>
            <PartnerRegistrationBackground />
            <BoxForm>
                <div className="partner-section">
                    <div className="partner-section-internal">
                        <h1>Partner Program</h1>
                        <p>
                            Our stores are looking for the best applications to connect to Shopfront,
                            join our partner program so they know how to find yours.
                        </p>
                    </div>
                </div>
                <div className="partner-section">
                    <div className="partner-section-internal">
                        <h2>What&apos;s the Partner Program?</h2>
                        <p>
                            The developer partner program allows developers to submit their application
                            into our integration marketplace to be easily seen by stores.
                        </p>
                        <p>
                            Application partners receive a number of benefits
                            such as:
                        </p>
                        <ul>
                            <li>Listings in our integration marketplace</li>
                            <li>Marketing opportunities directly to our customers</li>
                            <li>Priority developer support</li>
                            <li>Simplified setup for stores</li>
                            <li>
                                Ability for stores to integrate without requiring
                                the premium plan
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="partner-section">
                    <div className="partner-section-internal">
                        <h2>What&apos;s Required of Partners?</h2>
                        <p>
                            Shopfront requires that partners follow a strict set of
                            guidelines, these are still currently under development
                            but will include the following:
                        </p>
                        <ul>
                            <li>Use of the OAuth 2.0 state parameter</li>
                            <li>All embedded applications use TLS 1.3</li>
                            <li>Security self-assessment completed</li>
                            <li>Privacy policy for user data publicly available</li>
                            <li>Emergency contact details provided to Shopfront</li>
                            <li>Support information publicly available</li>
                            <li>Shopfront brand guidelines followed</li>
                            <li>Direct authorization from Shopfront supported</li>
                            <li>Use of authorization scopes</li>
                            <li>Consistently adding new stores</li>
                        </ul>
                    </div>
                </div>
                <div className="partner-section">
                    <div className="partner-section-internal">
                        <h2>What&apos;s the Process of Becoming a Partner?</h2>
                        <p>
                            Partner registration is a multi-step processes:
                        </p>
                        <ol>
                            <li>
                                {user === false && (
                                    <Link to="/register">Sign up as a developer</Link>
                                )}
                                {user !== false && (
                                    <>Sign up as a developer (done!)</>
                                )}
                            </li>
                            <li>
                                <a href="https://shopfront.com.au/signup">
                                    Sign up for a Shopfront trial store
                                </a>
                            </li>
                            <li>Build your integration (using your trial store)</li>
                            <li>Ensure your developer details are correct</li>
                            <li>Register as a partner</li>
                            <li>Submit your application for review</li>
                        </ol>
                        <p>
                            Whilst you&apos;re signing up for a trial store, it works and
                            functions the same way as a regular store. Developers are
                            eligible to extend their trial period by contacting us.
                        </p>
                        <p>
                            Registrations can be completed by pressing the button below.
                        </p>
                        <p>
                            Once you&apos;ve registered, you&apos;ll be required
                            to submit your application to Shopfront for a multi-part
                            review including application demonstration and security
                            self-assessment. Shopfront will work with you to ensure
                            your application meets quality standard and passes review.
                        </p>
                        <div style={{ textAlign: "center" }}>
                            <Link to="/partner/register">
                                <Button>Register Interest</Button>
                            </Link>
                        </div>
                        <p>
                            Whilst your application is in review it can still be integrated
                            with stores that are on Shopfront&apos;s premium plan.
                        </p>
                    </div>
                </div>
            </BoxForm>
        </main>
    );
};

export default PartnerProgram;
